/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Meta_TitleInputs */

const es_login_meta_title = /** @type {(inputs: Login_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Iniciar sesión`)
};

const en_login_meta_title = /** @type {(inputs: Login_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata | Login`)
};

/**
* | output |
* | --- |
* | "Nexata \| Login" |
*
* @param {Login_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_meta_title = /** @type {((inputs?: Login_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_meta_title(inputs)
	return en_login_meta_title(inputs)
});
export { login_meta_title as "login.meta.title" }